import { useNavigate } from "react-router-dom"

import { Box, Typography } from "@mui/material"
import { MenuItem } from "../../components/MenuItem"
import { ContentContainer, InitialsContainer, ItemContainer } from "./styled"
import UIIcon from "../../components/UIIcon"
import { ROUTES_PATHS } from "../../utils/constants"
import { PHKOString } from "../../components/PHKOString"
import { useGetUserInfo } from "../../api/hooks/useGetUserInfo"

import { TextContainer } from "../../components/MenuItem/styled"
import InitialsIcon from "../../components/InitialsIcon"

export const Settings = () => {
  const navigate = useNavigate()
  const { data } = useGetUserInfo()

  const  openOffer = () => {
    window.open('https://xn--80aaanetpw3ba4m.xn--p1ai/wp-content/uploads/Oferta_platezhnogo_servisa_Vimpelkom_RNKO.pdf')
  }

  return (
    <Box sx={ContentContainer}>
      <Box sx={ItemContainer}>
        <Box sx={InitialsContainer}>
          <InitialsIcon
            iconName="iconBox"
            size={46}
            lastNameLetter={data?.lastName?.[0] ?? '' as string}
            firstNameLetter={data?.firstName?.[0] ?? '' as string}
          />
          <Box sx={TextContainer}>
            <Typography variant="h4">{`${data?.lastName ?? ''} ${data?.firstName ?? ''}`}</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={ItemContainer}
        onClick={() => {
          navigate(`/${ROUTES_PATHS.limits}`)
        }}
      >
        <MenuItem icon="limitsIcon" title="Лимиты" />
        <UIIcon iconName="arrowForward" />
      </Box>
      <Box
        sx={ItemContainer}
        onClick={() => navigate(`/${ROUTES_PATHS.sbpSettings}`)}
      >
        <MenuItem
          icon="sbpBox"
          title="Система быстрых платежей"
          subtitle="Платежи и переводы"
        />
        <UIIcon iconName="arrowForward" />
      </Box>
      <Box sx={ItemContainer}
        onClick={() => openOffer()}>
        <MenuItem icon="docsBox" title="Оферта" />
        <UIIcon iconName="arrowForward" />
      </Box>
      <Box sx={ItemContainer}>
        <MenuItem
          icon="closeBox"
          title="Закрыть кошелек"
          subtitle="Закрыть Brand Pay"
        />
        <UIIcon iconName="arrowForward" />
      </Box>
      <PHKOString />
    </Box>
  )
}
